export enum questionTypeEnum {
  Descriptive = 'Descriptive – Rich text',
  MultipleChoice = 'Multiple choice standard',
  MultipleResponse = 'Multiple choice – Multi response choice',
  FillInTheBlank = 'Fill in the blanks',
}

export class mcqSingleChoiceRequest {
  itemStrategy: string;
  referenceText: string;
  numberOfQuestions: number;
  optionCount: number;
  enableTags: boolean;
}
